import { Component, Input } from '@angular/core';

@Component({
  selector: '[fieldRequired]',
  templateUrl: './fied-required.component.html',
  styleUrls: ['./fied-required.component.scss']
})
export class FiedRequiredComponent {

  @Input() valid = false
  @Input() required = true;

}
